var React = require('react');

function IconError (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10,0C4.4771729,0,0,4.4771729,0,10s4.4771729,10,10,10s10-4.4771729,10-10S15.5228271,0,10,0z\n\t M11.1242676,4.833313l-0.2490234,7.3901367H9.1174316L8.8684082,4.833313H11.1242676z M10.8532715,15.2996216\n\tc-0.2148438,0.210022-0.5005493,0.3149414-0.8569336,0.3149414c-0.3515625,0-0.637207-0.1049194-0.8569336-0.3149414\n\tc-0.2148438-0.2099609-0.3222656-0.4760742-0.3222656-0.7982788c0-0.3223267,0.1074219-0.5883789,0.3222656-0.7984009\n\tc0.2197266-0.2147827,0.5053711-0.3222046,0.8569336-0.3222046c0.3563843,0,0.6420898,0.1049194,0.8569336,0.3148804\n\tc0.2197876,0.210022,0.3295898,0.4785156,0.3295898,0.8057251C11.1828613,14.8235474,11.0730591,15.0896606,10.8532715,15.2996216z"}));
}

IconError.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = IconError;

IconError.default = IconError;
